module.exports = __webpack_public_path__ + "ec876bcbcb2a0315e196af37cd20fd6d.svg";